var amdi18n={"__root":{"detection_started":"Detection started","detection_successful":"Detection successful","detection_failed":"Detection failed","communication_started":"Starting Open eCard App communication","communication_successful":"Open eCard App communication successful started","communication_failed":"Open eCard App communication failed","wait_for_change_failed":"Open eCard App waitForChange failed","unknown_event":"Unknown event received","communication_stopped":"Stopped Open eCard App communication"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/model/eidclient/nls/OpeneCardApp_strings.js
// module id = 289
// module chunks = 3